<ng-container ntapWindowRegistry>
    <ntap-dynamic [compId]="filterCompId" #filterContainer></ntap-dynamic>
    <ntap-dynamic #tableComponent [compId]="tableCompId"></ntap-dynamic>
    <ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
        <ng-template #viewWindowContent let-defaultTemplate>
            <ntap-prime-popupview appendTo="body" [modal]="true">
                <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
            </ntap-prime-popupview>
        </ng-template>
    </ntap-view-window>
</ng-container>